import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import cogoToast from "cogo-toast";
import 'components-jqueryui';
import moment from "moment/moment";
import {GET_COLLECTION_AGGREGATE_DATA, GET_COLLECTION_DATA, SEARCH_COLLECTION_URL} from "../../../api";
import {capitalize} from "../../../utils/capitalize";
import {opportunity, sync} from "../../../api/app";
import {useDispatch, useSelector} from "react-redux";

let filter = {};

const searchableFields = [
    { field: 'description', isNumeric: false },
    { field: 'company.name', isNumeric: false },
    { field: 'position', isNumeric: false }
];

const Job = () => {

    document.title = "Opportunity";

    const dispatch = useDispatch();

    const token = localStorage.getItem('jwtToken');
    const [stateReady, setStateReady] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const {province, districts, constituencies, wards} = useSelector(state => state.app?.administrative);
    const [editId, setEditId] = useState(0);

    useEffect(() => {
        dispatch(sync());
    }, []);

    useEffect(() => {
        let table = $('#td-opportunity').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Opportunity Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        // query: $('.dataTables_filter input').val(),
                        // collection: "opportunity",
                        // fieldname: "name",
                        // filter: {
                        //     type: "job"
                        // },
                        // pageSize: data.start,
                        // format: 'json',
                        // populate: "company",
                        // pageIndex: (data.length + data.start) / data.length

                        query: $('.dataTables_filter input').val(),
                        collection: "opportunity",
                        searchableFields,
                        filter,
                        pageSize: data.start,
                        format: 'json',
                        populate: [
                            {
                                path: "company",
                                model: "company"
                            },
                            {
                                path: "admin_level.provincial",
                                model: "administrative"
                            },
                            {
                                path: "admin_level.district",
                                model: "district"
                            },
                            {
                                path: "admin_level.constituency",
                                model: "constituency"
                            }
                        ],
                        sort: { _id: -1 },
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];

                        res.data.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return capitalize(data.company.name);
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.position || "No Position";
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data?.location || "Unavailable";
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");
                    },
                    "targets": 4
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit-opportunity"><i class="fa fa-pencil"></i> Edit</a> <a href="#" class="nav-link delete-opportunity"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.delete-opportunity', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this opportunity?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                opportunity("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Opportunity successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.edit-opportunity', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            setEditForm(true);
            setEditId(extract_td.raw._id);

            let company_select = $("#company-select2");
            let $option_ = $("<option selected></option>").val(extract_td.raw.company._id).text(extract_td.raw.company.name);
            company_select.append($option_).trigger('change');

            initialize();

            if(extract_td.raw.admin_level?.provincial) {
                let provincial_select = $("#province");
                let $option = $("<option selected></option>").val(extract_td.raw.admin_level?.provincial?._id).text(extract_td.raw.admin_level?.provincial?.name);
                provincial_select.append($option).trigger('change');
            }

            if(extract_td.raw.admin_level?.district) {
                let district_select = $("#district");
                let _$option = $("<option selected></option>").val(extract_td.raw.admin_level?.district?._id).text(extract_td.raw.admin_level?.district?.name);
                district_select.append(_$option).trigger('change');
            }

            if(extract_td.raw.admin_level?.constituency) {
                let constituency_select = $("#constituency");
                let __$option = $("<option selected></option>").val(extract_td.raw.admin_level?.constituency?._id).text(extract_td.raw.admin_level?.constituency?.name);
                constituency_select.append(__$option).trigger('change');
            }

            $("#position").val(extract_td.raw.position);
            $("#description").val(extract_td.raw.description);
            $("#experience").val(extract_td.raw.experience);
            $("#responsibilities").val(extract_td.raw.responsibilities);
            $("#link").val(extract_td.raw.link);
            $("#qualifications").val(extract_td.raw.qualifications);
            $("#location").val(extract_td.raw.location);
            $("#date_from").val(extract_td.raw?.closeingDate);

            $('#opportunity_form').parsley();

            $("#modalOpportunity").modal("show");

            return false;
        });

        $('#td-opportunity tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Description:</td>' +
                '<td>' +
                `${d.raw?.description}` +
                '</td>' +
                '</tr>' +
                '<td>Qualification:</td>' +
                '<td>' +
                `${d?.raw?.qualifications}` +
                '</td>' +
                '</tr>' +
                '<td>Responsibilities:</td>' +
                '<td>' +
                `${d?.raw?.responsibilities}` +
                '</td>' +
                '</tr>' +
                '<tr>' +
                '<td>Closing Date:</td>' +
                '<td>' +
                moment(d?.raw?.closingDate).format("Do MMM, YYYY") +
                '</td>' +
                '</tr>' +
                '<td>Website Link:</td>' +
                '<td>' +
                `<nav class="nav nav-icon-only"><a target="_blank" href="${d.raw?.link}" class="nav-link"><i class="fa fa-eye"></i> View File</a></nav>` +
                '</td>' +
                '</tr>' +
                '</table>'
            );
        }

        return () => {
            table.destroy();
        }

    }, []);

    const reloadTable = () => {
        $('#td-opportunity').DataTable().ajax.reload(null, false);
    };

    const handleShowModal = () => {
        setEditForm(false);
        initializeSearch();

        $('#date_from').datepicker({
            showOtherMonths: true,
            selectOtherMonths: true,
            minDate: 1,
            defaultDate: '+1w',
            numberOfMonths: 1,
            dateFormat: 'yy-mm-dd'
        });

        initialize();
        $('#modalOpportunity').modal({backdrop: 'static', keyboard: false});
        $('#opportunity_form').parsley();
        $("#modalOpportunity").modal("show");
    }

    const handleOpportunitySubmit = (e) => {
        e.preventDefault();

        let description = $('#description').val();
        let position = $('#position').val();
        let experience = $('#experience').val();
        let responsibilities = $('#responsibilities').val();
        let qualifications = $('#qualifications').val();
        let location = $('#location').val();
        let link = $('#link').val();
        let province = $('#province').val()[0];
        let district = $('#district').val()[0];
        let constituency = $('#constituency').val()[0];
        let company = $('#company-select2').val();
        let date = $('#date_from').val();

        setStateReady(true);

        let data = {
            description,
            company,
            experience,
            responsibilities,
            qualifications,
            location,
            link,
            type: "job",
            position,
            closingDate: date,
            province,
            district,
            constituency
        }

        if(editForm) {
            opportunity("put", Object.assign(data, {id: editId})).then((result) => {
                setStateReady(false);

                if(!result.error) {
                    cogoToast.success("Data successfully updated.", {position: "top-right", hideAfter: 5});
                    resetForm("modalOpportunity", "opportunity_form");
                    reloadTable();
                }
            });

            return false;
        }

        opportunity("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Data successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalOpportunity", "opportunity_form");
                reloadTable();
            }
        });
    }

    const initializeSearch = () => {
        let company_select = $('#company-select2');
        let modalOpportunity = $('#modalOpportunity');
        company_select.select2({
            placeholder: 'Select company',
            allowClear: true,
            dropdownParent: modalOpportunity,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization" : token,
                },
                data: function (query) {
                    return {
                        query: query,
                        collection: "company"
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (item) {
                            return {
                                text: item.name,
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        }).on('select2:unselect', function(e) {
            $(".select2-search__field").css({display: "inline-block"});
        });
    }

    const initialize = () => {
        // Province
        $('#province').select2({
            placeholder: 'Select Provinces',
            multiple: true,
            width: '100%',
            data: province.map(p => ({ id: p._id, text: capitalize(p.name) }))
        });

        // Other dropdowns
        $('#district, #constituency, #ward, #polling_station').select2({
            placeholder: 'Select...',
            multiple: true,
            width: '100%'
        });

        // Province → District
        $('#province').on('change', function () {
            const selectedProvinces = $(this).val() || [];
            const filteredDistricts = districts.filter(d =>
                selectedProvinces.includes(d.administrative)
            );

            $('#district').empty().select2({
                placeholder: 'Select Districts',
                multiple: true,
                width: '100%',
                data: filteredDistricts.map(d => ({
                    id: d._id,
                    text: capitalize(d.name)
                }))
            }).val(null).trigger('change');

            $('#constituency, #ward, #polling_station')
                .val(null).trigger('change').empty();
        });

        // District → Constituency
        $('#district').on('change', function () {
            const selectedDistricts = $(this).val() || [];
            const filteredConstituencies = constituencies.filter(c =>
                selectedDistricts.includes(c.district)
            );

            $('#constituency').empty().select2({
                placeholder: 'Select Constituencies',
                multiple: true,
                width: '100%',
                data: filteredConstituencies.map(c => ({
                    id: c._id,
                    text: capitalize(c.name)
                }))
            }).val(null).trigger('change');
        });
    };

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Job Opportunity</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Job</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-plus"></i> Add New</button>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Job List</h6>
                                <div className="d-flex tx-18">
                                    <a href="#" onClick={(e) => {e.preventDefault(); $('#td-opportunity').DataTable().ajax.reload()}} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="td-opportunity" className="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-20p">Company</th>
                                        <th className="wd-25p">Position</th>
                                        <th className="wd-20p">Location</th>
                                        <th className="wd-15p">Date</th>
                                        <th className="wd-20p">Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalOpportunity" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <div className="media align-items-center">
                                    <div className="media-body">
                                        <a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close" onClick={resetForm.bind(null, "modalOpportunity", "opportunity_form")}>
                                            <span aria-hidden="true">&times;</span>
                                        </a>
                                        <h4 className="tx-18 tx-sm-20 mg-b-2">Create Job</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="opportunity_form" className="parsley-style-1" onSubmit={handleOpportunitySubmit.bind()}>
                                    <div id="positionWrapper" className="form-group parsley-input">
                                        <label>Position<span className="tx-danger">*</span></label>
                                        <input id="position" type="text" className="form-control"
                                               placeholder="Enter position name"
                                               autoComplete="off"
                                               data-parsley-class-handler="#positionWrapper" required/>
                                    </div>

                                    <div id="companyWrapper" className="form-group parsley-input">
                                        <div className="d-flex justify-content-between">
                                            <label>Company<span className="tx-danger">*</span></label>
                                        </div>
                                        <select className="form-control" id="company-select2" data-width="100%"
                                                data-parsley-class-handler="#companyWrapper"
                                                data-parsley-errors-container="#companyWrapper"
                                                autoComplete="off"
                                                required>
                                        </select>
                                    </div>

                                    <div id="descriptionWrapper" className="form-group parsley-input">
                                        <label>Description<span className="tx-danger">*</span></label>
                                        <textarea id="description" className="form-control" rows="6"
                                                  data-parsley-class-handler="#descriptionWrapper"
                                                  data-parsley-validation-threshold="10"
                                                  placeholder="Enter Description..." required></textarea>
                                    </div>

                                    <div id="locationWrapper" className="form-group parsley-input">
                                        <label>Location<span className="tx-danger">*</span></label>
                                        <input id="location" type="text" className="form-control"
                                               placeholder="Enter location name"
                                               autoComplete="off"
                                               data-parsley-class-handler="#locationWrapper"/>
                                    </div>

                                    <div id="linkWrapper" className="form-group parsley-input">
                                        <label>Link to Job Description/Application/Website<span
                                            className="tx-danger">*</span></label>
                                        <input id="link" type="text" className="form-control"
                                               placeholder="Enter link url"
                                               autoComplete="off"
                                               data-parsley-class-handler="#linkWrapper"
                                               required
                                        />
                                    </div>

                                    <div id="responsibilitiesWrapper" className="form-group parsley-input">
                                        <label>Responsibilities<span className="tx-danger">*</span></label>
                                        <textarea id="responsibilities" className="form-control" rows="6"
                                                  data-parsley-class-handler="#responsibilitiesWrapper"
                                                  data-parsley-validation-threshold="10"
                                                  placeholder="Enter Description..."></textarea>
                                    </div>

                                    <div id="qualificationsWrapper" className="form-group parsley-input">
                                        <label>Qualifications<span className="tx-danger">*</span></label>
                                        <textarea id="qualifications" className="form-control" rows="6"
                                                  data-parsley-class-handler="#qualificationsWrapper"
                                                  data-parsley-validation-threshold="10"
                                                  placeholder="Enter Qualifications..."></textarea>
                                    </div>

                                    <div id="experienceWrapper" className="form-group parsley-input">
                                        <label>Experience<span className="tx-danger">*</span></label>
                                        <textarea id="experience" className="form-control" rows="6"
                                                  data-parsley-class-handler="#experienceWrapper"
                                                  data-parsley-validation-threshold="10"
                                                  placeholder="Enter Experience..."></textarea>
                                    </div>

                                    <div id="provinceWrapper" className="form-group parsley-input">
                                        <label>Province</label>
                                        <select id="province"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#provinceWrapper"
                                                data-parsley-errors-container="#provinceWrapper"
                                                className="custom-select"
                                                required
                                        >
                                        </select>
                                    </div>

                                    <div id="districtWrapper" className="form-group parsley-input">
                                        <label>District</label>
                                        <select id="district"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#districtWrapper"
                                                data-parsley-errors-container="#districtWrapper"
                                                className="custom-select"
                                                required
                                        ></select>
                                    </div>

                                    <div id="constituencyWrapper" className="form-group parsley-input">
                                        <label>Constituency</label>
                                        <select id="constituency"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#constituencyWrapper"
                                                data-parsley-errors-container="#constituencyWrapper"
                                                className="custom-select"
                                        ></select>
                                    </div>

                                    <div id="dateWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Select Closing Date<span className="tx-danger">*</span></label>
                                        <input type="text"
                                               id="date_from"
                                               className="form-control"
                                               placeholder="Select Closing Date"
                                               autoComplete="off"
                                               data-parsley-class-handler="#dateWrapper"
                                               readOnly
                                        />
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-success btn-block"><span
                                        className="spinner-border spinner-border-sm mg-r-10" role="status"
                                        aria-hidden="true"/><span id="status">Please Wait</span></button> : editForm ?
                                        <button className="btn btn-success btn-block">Update Job</button> :
                                        <button className="btn btn-success btn-block">Create Job</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation"
                     aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Job;
